export default __webpack_public_path__ + "static/N0078-5a179e74f4cb14d85d793fbebfb28606.png";